import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'

const BackdropWithModalStyles = styled(BackdropModal)`
	.add-product-section-title {
		color: #cdcdcd;
		font-size: 1rem;
	}

	.add-product-form-label {
		color: #6f6f6f;
		font-size: 0.875rem;
	}

	.add-product-form-input {
		margin-bottom: 16px;
	}

	.add-product-modal-action-part {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-top: 12px;

		.add-product-modal-cancel-button {
			margin-right: 10px;
		}
	}
`

const FileUploadInput = styled.input`
	display: none;
`

const NameWrapper = styled.div`
	white-space: nowrap;
	width: 100%;
	overflow: hidden;
	-o-text-overflow: ellipsis;
	text-overflow: ellipsis;
`

export { BackdropWithModalStyles, FileUploadInput, NameWrapper }
